/**
 * An intermediate entity to manage the car information. This entity represents
 * what the form displays, but it is not a direct representation of what a 'unit' is
 * (the real car entity in the data layer)
 */
type CarItem = {
  /** Required parameters */
  brand: string;
  model: {
    id: string;
    groupId?: string | null;
    name: string;
    brand: string;
  };
  year: number;
  value: number;
  typeOfMoney: string;
  licensePlate: string;
  category: string;
  hasBill: boolean;
  use: string;
  passengersQty: string;
  serialChassis: string;
  serialMotor: string;
  fuel: string;
  treasuryValue: string;
  cylinder: string;
  color: string;
  /** This parameter must be optional, since it can have no default value on the form */
  isNewCar?: boolean;
  noLicensePlate: boolean;
};

export function makeEmpty(): CarItem {
  return {
    cylinder: '',
    fuel: '',
    passengersQty: '0',
    serialChassis: '',
    serialMotor: '',
    treasuryValue: '0',
    brand: '',
    model: {
      id: '',
      groupId: '',
      name: '',
      brand: '',
    },
    year: 0,
    value: 0,
    typeOfMoney: '',
    licensePlate: '',
    category: '',
    use: '',
    hasBill: false,
    color: '',
    noLicensePlate: false,
  };
}

export default CarItem;
